'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _dec4, _dec5, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _class2, _temp;

var _mobx = require('mobx');

var _debounce = require('debounce');

var _debounce2 = _interopRequireDefault(_debounce);

var _simgateInputStore = require('simgate-input-store');

var _simgateInputStore2 = _interopRequireDefault(_simgateInputStore);

var _deepExtend = require('deep-extend');

var _deepExtend2 = _interopRequireDefault(_deepExtend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ProjectDomainStore = (_dec = _mobx.action.bound, _dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, _dec4 = _mobx.action.bound, _dec5 = _mobx.action.bound, (_class = (_temp = _class2 = function (_SimgateInputStore) {
  (0, _inherits3.default)(ProjectDomainStore, _SimgateInputStore);

  function ProjectDomainStore() {
    (0, _classCallCheck3.default)(this, ProjectDomainStore);

    // //@TODO put this in sim shell?
    // let pauseTimeout;
    // // user timeout functionality @TODO move to global domain store?
    // const checkTimer = debounce( () => {
    //   if(pauseTimeout === true) return          
    //   const thisTime = +new Date;
    //   if(this.hasRefreshed && (thisTime - this.hasRefreshed) > this.timeoutWarningDelay){
    //     this.refreshContext(timeouter);
    //   }
    //   timeouter()
    // }, 100)

    // const timeouter = debounce( () => {
    //   pauseTimeout = true;
    //   shell && shell.confirm && shell.confirm(
    //     "You are about to timeout.  Please click OK to refresh your session.  Please click CANCEL to logout.",
    //     confirm => {
    //       if(confirm){
    //         this.refreshContext(() => {
    //           pauseTimeout = false;
    //           timeouter();
    //         })
    //       }else{
    //         shell.signOut();
    //         return false; // this keeps callback from hiding alert
    //       }
    //     }
    //   )
    // }, this.timeoutWarningDelay );
    // timeouter();

    // document.querySelector("body").addEventListener("mousemove", checkTimer);
    var _this = (0, _possibleConstructorReturn3.default)(this, (ProjectDomainStore.__proto__ || (0, _getPrototypeOf2.default)(ProjectDomainStore)).apply(this, arguments));

    _initDefineProp(_this, 'isRefreshing', _descriptor, _this);

    _initDefineProp(_this, 'contextIsLoaded', _descriptor2, _this);

    _initDefineProp(_this, 'hasRefreshed', _descriptor3, _this);

    _initDefineProp(_this, 'context', _descriptor4, _this);

    return _this;
  }

  // timeoutWarningDelay = (1000 * 60) * 45 // minutes

  // @TODO make into computed (hasRefreshed - willRefresh > 0)


  (0, _createClass3.default)(ProjectDomainStore, [{
    key: 'signOut',
    value: function signOut(cb, errCb) {
      this._signOut.apply(this, arguments);
    }
  }, {
    key: '_signOut',
    value: function _signOut(cb, errCb) {
      if (!this.simgate) throw new Error("missing simgate");
      this.simgate.signOut().then(cb).catch(errCb);
    }
  }, {
    key: 'signIn',
    value: function signIn(claim, cb, errCb) {
      var _this2 = this;

      if (!this.simgate) throw new Error("missing simgate");
      var signOutCb = function signOutCb() {
        _this2.simgate.signIn(claim).then(function (res) {
          if (!res || !res.context) throw new Error("Access denied.");
          (0, _deepExtend2.default)(_this2.context, res.context);

          _this2.contextIsLoaded = true;
          if (typeof cb === "function") cb();
        }).catch(errCb);
      };

      this.simgate.signOut().then(signOutCb).catch(signOutCb);
    }
  }, {
    key: 'createUser',
    value: function createUser(create, cb, errCb) {
      if (!this.simgate) throw new Error("missing simgate");
      var taskArgs = [this.simgate.register, {
        pin: "pass",
        path: 3,
        user: create,
        signIn: create.signIn ? true : false,
        init: create.init ? true : false
      }, {
        onSuccess: cb,
        onFailure: errCb
      }];
      if (this.simgate.runTask) {
        var _simgate;

        (_simgate = this.simgate).runTask.apply(_simgate, taskArgs);
      } else if (this.simgate.AsyncTask) {
        var asyncTask = new this.simgate.AsyncTask();
        asyncTask.runTask.apply(asyncTask, taskArgs);
      } else {
        this.simgate.register(taskArgs[1]).then(cb).catch(errCb);
      }
    }
  }, {
    key: 'refreshContext',
    value: function refreshContext(cb, errCb) {
      var _this3 = this;

      if (!this.simgate) throw new Error("missing simgate");
      this.isRefreshing = true;
      var callback = (0, _mobx.action)("getContext-callback", function (res) {
        if (_this3.contextIsLoaded && res.context.pathID === 0) throw new Error('{"IsError":true,"ErrorMessage":"Access denied. Lost simgate context!"}');

        (0, _deepExtend2.default)(_this3.context, res.context);

        _this3.isRefreshing = false;
        _this3.hasRefreshed = +new Date();
        _this3.contextIsLoaded = true;

        if (typeof cb === "function") cb();
      });

      var taskArgs = [this.simgate.getContext, {}, {
        onSuccess: callback,
        onFailure: errCb
      }];
      if (this.simgate.runTask) {
        var _simgate2;

        (_simgate2 = this.simgate).runTask.apply(_simgate2, taskArgs);
      } else if (this.simgate.AsyncTask) {
        var asyncTask = new this.simgate.AsyncTask();
        asyncTask.runTask.apply(asyncTask, taskArgs);
      } else {
        this.simgate.getContext(taskArgs[1]).then(callback).catch(errCb);
      }

      return this;
    }
  }]);
  return ProjectDomainStore;
}(_simgateInputStore2.default), _class2.id = "domainStore", _temp), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'isRefreshing', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'contextIsLoaded', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'hasRefreshed', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'context', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {
      get username() {
        return this.user.loginName;
      },
      set username(val) {
        this.user.loginName = val;
      },
      user: {
        loginName: "",
        userID: 0,
        // simgate compatibility:
        get id() {
          return this.userID;
        },
        set id(val) {
          this.userID = val;
        },
        pathID: 0,
        roleID: 0,
        // simgate compatibility:
        get roleId() {
          return this.roleID;
        },
        set roleId(val) {
          this.roleID = val;
        },
        email: "",
        properties: ""
      },
      sessionName: "--",
      team: {
        get id() {
          return this.pathId;
        },
        set id(val) {
          this.pathId = val;
        },
        pathId: 0,
        name: "--",
        pathType: 2,
        parentId: 0,
        attr1: 0,
        attr2: 0,
        attr3: 0,
        attr4: 0,
        attr5: 0,
        num1: 0,
        num2: 0,
        num3: 0,
        num4: 0,
        num5: 0
      },
      // @TODO gets set by session selector!
      simParentPathId: 0
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, 'signOut', [_dec], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'signOut'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_signOut', [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, '_signOut'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'signIn', [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'signIn'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'createUser', [_dec4], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'createUser'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'refreshContext', [_dec5], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'refreshContext'), _class.prototype)), _class));
exports.default = ProjectDomainStore;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ProjectDomainStore, 'ProjectDomainStore', 'src/core_modules/project-domain-store/index.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/platform-client-bootstrap/dist/core_modules/project-domain-store/index.js
// module id = ./node_modules/platform-client-bootstrap/dist/core_modules/project-domain-store/index.js
// module chunks = 0